import React from 'react';
import styles from "./QBOButton.module.scss";
import { QboIcon } from "../../integrations/QBO/QboIcon";
import { Spinner } from 'seagull';
export function QBOButton(_ref) {
  let {
    children,
    hideIcon,
    loading,
    onClick,
    'data-testid': testid
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    className: styles.root,
    onClick: onClick,
    disabled: loading,
    "data-testid": testid
  }, !hideIcon && /*#__PURE__*/React.createElement(QboIcon, null), children, loading && /*#__PURE__*/React.createElement("div", {
    className: styles.loading,
    "data-testid": testid && "".concat(testid, "-loading")
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 32
  })));
}